"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addMessage = addMessage;

function addMessage(field, message, type) {
  message = message.replace('{key}', field);
  return {
    field: field,
    type: type,
    message: message
  };
}